import moment from "moment";

const BankIdValidFrom = ({ validFrom }) => {
  if (validFrom != null) {
    const dateFrom = moment(validFrom);
    const dateNow = moment();
    const daysBetween = dateNow.diff(dateFrom, "days");

    return <span> {daysBetween} days</span>;
  }
  return null;
};
export default BankIdValidFrom;
